import appStoreIcon from './appstore.svg';

let Slide1 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2F1.png?alt=media&token=bf9dcc25-5277-454f-a89f-b652f1d295e9"
let Slide2 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2F2.png?alt=media&token=0e7e89b2-590d-4ca6-ad93-bdfaabba4aa3"
let Slide3 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2F3.png?alt=media&token=1003d5d8-3166-4720-9efd-1a53a53f7650"
let Slide4 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2F4.png?alt=media&token=55a45ad1-b560-4a89-a74b-5e14bd3b4234"
let Slide5 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2F5.png?alt=media&token=3c794095-5a62-4dd3-9fff-d988f55c09fe"

let newSlide1 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2Fslide_1.png?alt=media&token=83cfad60-0813-42dc-ad6b-709c61cecd5e" 
let newSlide2 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2Fslide_2.png?alt=media&token=e9b1de6a-682e-4a99-b934-04fad22f801f"
let newSlide3 = "https://firebasestorage.googleapis.com/v0/b/memesical.firebasestorage.app/o/web_slides%2Fslide_3.png?alt=media&token=4f2e3c0e-20e6-4809-9f8a-cd772d6cb206"

export {
    Slide1,
    Slide2,
    Slide3,
    Slide4,
    Slide5,
    newSlide1,
    newSlide2,
    newSlide3,
    appStoreIcon
};